import React, { useCallback } from 'react';
import cn from 'classnames';

import { CategoryProps } from '@components/ui/CategoryList/CategoryList.props';

import styles from './CategoryOverview.module.scss';
import Props from './CategoryOverview.props';
import CategoryList from '@components/ui/CategoryList/CategoryList';

const CategoryOverview = ({ categories, removeDoubles = false, className }: Props) => {
  if (!categories) return null;

  const getGroupedCategories = useCallback(() => {
    const sortedCategories = categories
      .filter(
        (category, idx, self) =>
          !removeDoubles || idx === self.findIndex((target) => target.label === category.label),
      )
      .sort((categoryA, categoryB) => {
        const a = categoryA.label.toLowerCase();
        const b = categoryB.label.toLowerCase();

        if (a < b) return -1;
        if (a > b) return 1;

        return 0;
      });

    const groupedCategories: { [key: string]: CategoryProps[] } = {};

    sortedCategories.forEach((category) => {
      const firstChar = category.label[0];

      if (!groupedCategories[firstChar]) groupedCategories[firstChar] = [];

      groupedCategories[firstChar].push(category);
    });

    return groupedCategories;
  }, [categories]);

  const CategoryListElements = Object.entries(getGroupedCategories()).map(([letter, list]) => (
    <li key={letter} className={styles.CategoryList} data-testid="categoryList">
      <CategoryList letter={letter} categories={list} />
    </li>
  ));

  return <ul className={cn(styles.CategoryOverview, className)}>{CategoryListElements}</ul>;
};

export default CategoryOverview;
